import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import NyamNyamLab from './NyamNyamLab';

ReactDOM.render(
    // <React.StrictMode>
    //   <App />
    // </React.StrictMode>,
    
    <NyamNyamLab />,
    document.getElementById('root')
);